import styled from '@emotion/styled';
import { IconButton } from '@mui/material';

/**
 * A MUI `IconButton` with cursor set to `pointer`
 */
const ActionIconButton = styled(IconButton)`
  &:hover {
    cursor: pointer;
  }
`;

export default ActionIconButton;